<template>
  <div>
    <div class="survey-wrapper">
      <div v-if="loading" class="loading-dots-loader"></div>
      <div v-else style="text-align: center;">
        <h1 class="py-2"> {{ surveyData.name }}</h1>
        <div v-if="view == 'start'" style="text-align: center;">
          <p v-html="surveyData.intro"></p>
          <div style="max-width: 500px; margin: 30px auto;">
            <v-form ref="clientInformationForm" v-model="clientInformationValid">
              <v-text-field
                outlined
                v-model="clientData.firstName"
                :counter="30"
                dense
                :rules="nameRules"
                :label="text[language.toLowerCase()].firstName"
                background-color="#f1f1f1"
              ></v-text-field>
              <v-text-field
                outlined
                v-model="clientData.lastName"
                :counter="30"
                dense
                :rules="nameRules"
                :label="text[language.toLowerCase()].lastName"
                background-color="#f1f1f1"
              ></v-text-field>
              <v-text-field
                outlined
                dense
                v-model="clientData.email"
                :rules="emailRules"
                :label="text[language.toLowerCase()].email"
                required
                background-color="#f1f1f1"
              ></v-text-field>
              <div class="d-flex" v-if="surveyData.askPhone">
                <v-select
                  class="d-flex pr-2"
                  style="max-width:150px;"
                  outlined
                  dense
                  background-color="#f1f1f1"
                  :items="languagesPhone"
                  v-model="selectedPhoneLanguage"
                  item-text="item"
                  >
                  <template slot="selection" slot-scope="data">
                    <country-flag :country="data.item.flag" />
                    <span class="pl-2">{{ data.item.lang }}</span>
                  </template>
                  <template slot="item" slot-scope="data">
                    <country-flag :country="data.item.flag" size="small" />
                    <span class="pl-2">{{ data.item.lang }}</span>
                  </template>
                </v-select>

                <v-text-field
                  class="d-flex"
                  outlined
                  background-color="#f1f1f1"
                  dense
                  v-model="tel"
                  :counter="12"
                  :rules="telRules"
                  :label="text[language.toLowerCase()].phone"
                  required
                ></v-text-field>
              </div>
            </v-form>
            
            <v-btn v-if="questionsStart" block depressed :color="color" :disabled="!valid" :dark="valid" @click="findResult()">{{ text[language.toLowerCase()].sendResults }}</v-btn>
            <v-btn v-else block depressed :color="color" :disabled="!valid" :dark="valid" @click="startSurvey()">{{ text[language.toLowerCase()].start }}</v-btn>
            <p style="padding: 20px 0 0 0;text-align: center; font-style: italic; font-size: 14px; color: #333;">{{ surveyData.disclaimer }}</p>
          </div>
        </div>
        <div v-if="view == 'questions'">
          <h3 class="py-3"> {{ currentQuestion.question }} </h3>
          <v-card outlined flat v-if="currentQuestion.type == 'multiText'">
            <v-list dense class="pa-0 ma-0">
              <div v-for="(answer, index) in currentQuestion.answers" :key="index">
                <v-list-item color="primary" @click="answerSelected(answer.id)" :input-value="(selectedAnswer == answer.id)">
                <v-list-item-content>
                  <v-list-item-title>{{ answer.text}}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                  class="pa-0 ma-0" 
                  v-if="index < currentQuestion.answers.length - 1"
                  :key="index"
                ></v-divider>
              </div>
            </v-list>
          </v-card>

          <v-card flat v-else-if="currentQuestion.type == 'multiImages'">
            <v-container class="ma-0 pa-0 pa-2" >
              <v-layout row wrap>
                <v-flex md3 xs6 v-for="(answer, index) in currentQuestion.answers" :key="index">
                  <v-card outlined flat class="ma-1" @click="answerSelected(answer.id)">
                    <v-img
                      height="200"
                      :src="answer.imageUrl"
                      >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                          contain
                          >
                          <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                        </v-row>
                      </template>
                    
                    </v-img>

                    <v-card-title class="pa-0 ma-1" style="text-align: center; display: block; font-size: 16px">{{ answer.text }}</v-card-title>
                  </v-card>
                </v-flex>
              </v-layout>
          
            </v-container>
          </v-card>

          <v-card outlined flat v-else>
            <div v-for="(answer, index) in currentQuestion.answers" :key="index" :class="{'active': selectedAnswer == answer.id}" @click="answerSelected(answer.id)"> {{ answer.text }}</div>
          </v-card>

          <div class="button">
            <v-container class="ma-0 mt-3 pa-3">
              <v-layout row wrap>
                <v-flex  sm="6" class="text-left">
                  <v-btn v-if="givenAnswers.length > 0" :color="color" depressed @click="previousQuestion()">{{ text[language.toLowerCase()].previous }}</v-btn> 
                </v-flex>
                <v-flex sm="6" class="text-right">
                  <v-btn v-if="useNext" :disabled="!selectedAnswer" :color="color" depressed @click="nextQuestion()">{{ text[language.toLowerCase()].next }}</v-btn> 
                </v-flex>
              </v-layout>
            </v-container>
          </div>
        </div>
        <div v-if="view == 'result'" style="padding: 15px 0;">
          <div v-if="!surveyData.showResult" style="padding: 15px; text-align: center; border-radius: 5px;" :style="{'background-color': color}">
            {{ text[language.toLowerCase()].thanks }} {{ clientData.firstName}}. {{ text[language.toLowerCase()].emailReceive }}
          </div>
          <div class="my-2" v-if="surveyData.showResult || test" style="padding: 15px; text-align: center; border-radius: 5px;" :style="{'background-color': color}">

            <h2 v-if="surveyResult.title">{{ surveyResult.title }}</h2>
            <h2 v-else>{{ text[language.toLowerCase()].result }}</h2>
            <p class="ma-0 pa-0" v-html="surveyResult.text"></p>
          </div>
        </div>
        <div v-if="view == 'error'" style="padding: 15px 0;">
          <div style="padding: 15px; text-align: center; border-radius: 5px; background-color: #f1f1f1">
            <h2>{{ surveyError.title }}</h2>
            <p class="ma-0 pa-0">{{ surveyError.text }}</p>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import db from "../firebase/init";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import CountryFlag from "vue-country-flag";
import phoneVal from "phone";

const Pushover = require("pushover-js").Pushover;
const pushover = new Pushover(
  "gotopzd5rgmjmj6qatoxpdeurhpukh",
  "ao3wq1j4tvsbn5sd39sxg6g5m1ijtc"
);

export default {
  name: "survey",
  props: {
    companyId: String,
    survey: String,
    test: Boolean,
    userAgent: String,
    source: String,
    language: String,
    questionsStart: Boolean,
    calculatorCountry: String
  },

  components: { CountryFlag },

  data: function () {
    return {
        useNext: false,
        view: 'start',
        surveyResult: null,
        loading: true,
        surveyError: null,
        surveyData: null,
        clientData: {
          firstName: "",
          lastName: "",
          email: "",
          ip: ""
        },
        text: {
          nl: {
            start: "Starten",
            next: "Volgende",
            previous: "Vorige",
            firstName: "Voornaam",
            lastName: "Achternaam",
            email: "E-mail",
            phone: "Telefoon",
            result: "Resultaat",
            thanks: "Bedankt voor het invullen ",
            emailReceive: "Je ontvangt binnen 5 minuten van ons een e-mail met het resultaat.",
            sendResults: 'Bekijk resultaat'
          },
          en: {
            start: "Start",
            next: "Next",
            previous: "Previous",
            firstName: "Firstname",
            lastName: "Lastname",
            email: "E-mail",
            phone: "phone",
            result: "Result",
            thanks: "Thank you for completing",
            emailReceive: "You will receive an email from us with the result within 5 minutes.",
            sendResults: 'See results'
          },
        },
        
        emailRules: [
          v => !!v || "E-mail is verplicht",
          v => /.+@.+\..+/.test(v) || "E-mail is verplicht"
        ],
        nameRules: [
          v => !!v || "Verplicht veld",
          v => (v && v.length <= 30) || "Maximaal 30 characters"
        ],
        surveyConversionDocId: null,
        clientInformationValid: false, 
        questions: new Array(),
        selectedAnswer: null,
        givenAnswers: new Array(),
        currentQuestion: {
            id: 1,
            question: "Mijn haarlengte is nu:",
            type: "multiImages",
            answers: [
              {
                id: 10,
                imageUrl: "",
                text: "Kort haar"
              },
              {
                id: 11,
                imageUrl: "",
                text: "Boblijn"
              },
              {
                id: 15,
                imageUrl: "",
                text: "Lang haar"
              },
            ]
        },
        telRules: [
          v => !!v || this.$t("phoneRequired"),
          v => v.length > 8 || this.$t("phoneRequired"),
          v => /^[0-9+]*$/.test(v) || this.$t("phoneValid"),
        ],
        tel: "",
        telTemp: "",
        phone: "",
        languagesPhone: [
          { lang: "+31", flag: "nl", phone: "NLD" },
          { lang: "+32", flag: "be", phone: "BE" },
          { lang: "+49", flag: "de", phone: "DE" },
          { lang: "+1", flag: "us", phone: "USA" },
          { lang: "+1", flag: "ca", phone: "CAN" },
          { lang: "+7", flag: "ru", phone: "RUS" },
          { lang: "Other", flag: "nl", phone: "Other" }
        ],
        selectedPhoneLanguage: { lang: "+31", flag: "nl", phone: "NLD" },
        
      }
  },

  mounted() {
    //Google GTM 
    this.$gtm.trackView("surveyScreen", "widgetPath");
  },

  created() {
    if(this.questionsStart){
      this.view = "questions";
    }
    this.loadSurvey(this.survey); // Load Survey
  },
  methods: {

    loadSurvey(survey){
      this.loading = true;
      this.surveyData = new Object();
      db.collection("widgetSurveys").doc(survey).get()
        .then(doc => {
          let surveyData = doc.data();
          surveyData.id = doc.id;
          this.surveyData = surveyData;
          this.questions = surveyData.questions;
        })
        .then(() => {
          this.questions.forEach(question=>{
            if(!question.showConditions || question.showConditions.length == 0){
              this.currentQuestion = question;
            }
          })
          this.loading = false;
        })
        .catch(error=>{
          console.error("error getting Survey: ", error)
        })
    },

    startSurvey(){
      this.setSurveyConversion();
      this.view = "questions";
    },
    
    getNextQuestion(questionId, answerId){
      if(this.questionsStart && !this.surveyConversionDocId){
        this.setSurveyConversion();
      }
      let counter = 0;
      let nextQuestion = null;
      new Promise((resolve)=>{
        this.questions.forEach(question=>{
          if(question.showConditions && question.showConditions.length > 0){
            question.showConditions.forEach(condition=>{
              if(condition.questionId == questionId && condition.answerId == answerId){
                nextQuestion = _.cloneDeep(question)
                resolve(nextQuestion)
              }
            })
          }
          counter++
          if(counter == this.questions.length){
            resolve(nextQuestion)
          }
        })
      })
      .then((nextQuestion)=>{
        if(nextQuestion){
          this.currentQuestion = nextQuestion;
          this.selectedAnswer = null;
          if(this.surveyConversionDocId){
            this.updateSurveyConversion("busy")
          }
        }
        else{
          if(this.questionsStart){
            this.view = 'start'
          }
          else{
            this.findResult();
          }
        }
      })
    },

    nextQuestion(){
      if(this.givenAnswers.length == 0 || (this.givenAnswers[0].questionId != this.currentQuestion.id && this.givenAnswers[0].answerId != this.selectedAnswer)){
        this.givenAnswers.unshift({
          questionId: this.currentQuestion.id,
          answerId: this.selectedAnswer
        });
        this.getNextQuestion(this.currentQuestion.id, this.selectedAnswer)
      }
      else{
        // console.log("antwoord is al gegeven")
      }
    },

    answerSelected(id){
      this.selectedAnswer = id;
      if(!this.useNext){
        this.nextQuestion();
      }
    },

    previousQuestion(){
      this.questions.forEach(question=>{
        if(question.id == this.givenAnswers[0].questionId){
          this.currentQuestion = _.cloneDeep(question);
          if(this.givenAnswers.length == 1){
            this.givenAnswers = new Array();
          }
          else{
            this.givenAnswers.shift();
          }          
        }
      })
    },

    async findResult(){
      this.surveyError = null;
      if(this.surveyData.results && this.surveyData.results.length > 0){
        // Create Id to match
        let id = "";
        this.givenAnswers.forEach(answer=>{
          id = answer.answerId + id;
        })
        //
        new Promise((resolve, reject)=>{
          let counter = 0;
          this.surveyData.results.forEach(result=>{
            if(result.id == id){
              //console.log("result gevonden: ", result.id, id)
              resolve(result)
            }
            counter++
            if(counter == this.surveyData.results.length){
              //console.log("Geen resultaat gevonden")
              resolve()
            }
          })
        })
        .then(data => {
          // console.log("resolved: ", data)
          

          if(data.text){
            this.loading = true;
            this.surveyResult = data;
            let counter = 0;
            new Promise((resolve)=>{
              this.updateSurveyConversion("completed").then((data)=>{
                // console.log("updateSurveyConversion", data);
                counter++
                if(counter == 2){
                  resolve()
                }
              })
              this.postDataMautic("completed").then((data)=>{
                // console.log("postDataMautic", data);
                counter++
                if(counter == 2){
                  resolve()
                }
              })
            })
            .then(()=>{
              
              //Conversie Invullen

              window.dataLayer?.push({
                    event: 'conversionSurvey',
                    label: 'Survey Sessions',
                    category: 'surveyEvents',
                    companyId: this.companyId,
                    
                 });

              if(this.surveyData.useSuccessPage && this.surveyData.successPageUrl){
                window.parent.location.href = this.surveyData.successPageUrl;
                this.loading = false; 
              }
              else{
                this.view = "result";
                this.loading = false;
              }
              
            })
          }
          else{
            let surveyError = {
              title: "Er is iets fout gegaan.",
              text: "Het resultaat kan niet worden gevonden."
            };
            this.surveyError = surveyError;
            this.view = "error";   
          }
         
        })
        .catch(error => {
          let surveyError = {
              title: "Er is iets fout gegaan.",
              text: "Het resultaat kan niet worden gevonden."
            };
          this.surveyError = surveyError;
          this.view = "error";
          if(error){
            console.error("Error finding result: ", error)
          }
          
        })
      }
      else{
        // No Results to show
      }
    },
    

    setSurveyConversion(){
      axios
        .get(
          `https://pro.ip-api.com/json/?key=M08tSvdEklYEPub&fields=status,message,continentCode,country,countryCode,region,regionName,city,zip,lat,lon,timezone,isp,org,as,mobile,proxy,hosting,query`
        )
        .then(response => {
          this.clientData.ip = response.data;
        })
        .catch(error => {
          this.clientData.ip = "";
        });
      db.collection("surveyConversion")
        .add({
          clientData: {
            device: this.userAgent, //Dynamisch maken
            userAgent: navigator.userAgent,
            email: this.clientData.email,
            phone: this.telTemp,
            ip: this.clientData.ip,
            name: this.clientData.firstName + " " + this.clientData.lastName
          },
          companyId: this.companyId,
          timestamp: new Date(),
          timestampUpdated: new Date(),
          type: "survey",
          source: this.source,
          surveyData: {
            id: this.survey,
            answers: this.givenAnswers
          },
          progress: {
            availableForAction: true,
            completed: false,
            completedBy: "user",
            completedOn: null
          },
        })
        .then(docRef => {

           window.dataLayer?.push({
                    event: 'conversionSurvey',
                    category: 'widgetEvents',
                    label: 'Widget Sessions',
                    email: this.clientData.email,
                    phone: this.telTemp,
                    name: this.clientData.firstName + " " + this.clientData.lastName,
                    companyId: this.companyId,

                 });

          this.surveyConversionDocId = docRef.id;
          this.postDataMautic();
          this.postPushover();
          // console.log("Doc set")
        })
        .catch(error => {
          console.error("Error creating SurveyConversion doc : ",error);
        });
    },

    async updateSurveyConversion(status){
      let completedOn = status == 'completed' ? new Date() : null;
      let completed = status == 'completed' ? true : false;
      let availableForAction = status == 'completed' ? false : true;
      await db.collection("surveyConversion").doc(this.surveyConversionDocId)
        .set({
          clientData: {
            device: this.userAgent,
            userAgent: navigator.userAgent,
            email: this.clientData.email,
            ip: this.clientData.ip,
            name: this.clientData.firstName + " " + this.clientData.lastName
          },
          timestampUpdated: new Date(),
          surveyData: {
            id: this.survey,
            answers: this.givenAnswers,
            surveyResult: this.surveyResult
          },
          progress: {
            availableForAction: availableForAction,
            completed: completed,
            completedBy: "user",
            completedOn: completedOn
          },
        }, {merge: true})
        .catch(error => {
          console.error("Error updating SurveyConversion doc : ",error);
        });
        return "success"
    },

    async postDataMautic(status){
      //console.log("function postDataMautic: ", status)
      if(!this.test && this.surveyData.useMautic && this.surveyData.mauticUrl){
        let data ={
          firstname: this.clientData.firstName,
          lastname: this.clientData.lastName,
          email: this.clientData.email,
          calculatoradvice: this.surveyResult && this.surveyResult.text ? this.surveyResult.text : "",
          calculator: moment().format("YYYY-MM-DD"),
          calculatorCountry: this.calculatorCountry ? this.calculatorCountry : 'nl',
          urlMail: this.surveyData.mauticUrl,
          firstsource: "chatbot"
        }
        //axios.post('http://localhost:8888/calculator', data)
        let conctatId = null;
        await axios.post('https://chatsend.hogans.nl/calculator', data)
        .then((response) => {
          if(response.data.id){
            conctatId = response.data.id
          }
          else{ // Geen contactId
            conctatId = null
          }
        }, (error) => {
          console.error("Error sending data to calculator", error);
        });
        if(status == 'completed' && conctatId){
         await this.sendMauticEmail(conctatId).then(()=>{
          // console.log("sendMauticEmail returned")
          })
          return status
        }
        else{
          return status
        }
      }
      else{
        return status
      }
    },

    postPushover(){
      if(this.companyId == 'lamaison' || this.companyId == 'amsterdambeautycentrum'){
        let message = {
          subject: `Lead${this.surveyData.name}`,
          message: `Configurator gestart door ${this.clientData.firstName}`
        };
        let sound = 'pushover';
        pushover
          .setSound(sound) // Setting the sound
          .setPriority(1) // If the priority is 2, you have to provide an expire time and a retry time (see the official API for more info)
          .setUrl('https://app.pillarrr.io/', 'Pillarrr') // Set an url to access on tap
          .setTimestamp(Math.floor(new Date(2020, 2, 1).getTime() / 1000)) // Set custom timestamp (unix timestamp, not javascript time!!!)
          .send(`${message.subject}`, `${message.message}`) // Send
          .then((msj) => {
            return;
          })
          .catch((e) => {
            console.error("pushover: ", e);
          });
      }
    },

    async sendMauticEmail(contactId){
      if(!this.test && this.surveyData.useMautic && this.surveyData.mauticUrl && this.surveyData.mauticEmailId){
        let data ={
          emailId: this.surveyData.mauticEmailId,
          contactId: contactId,
          url: this.surveyData.mauticUrl,
        }
        //axios.post('http://localhost:8888/surveyEmail', data)
        await axios.post('https://chatsend.hogans.nl/surveyEmail', data)
        .then((response) => {
          // console.log("response: ", response)
        }, (error) => {
          console.error("Error sending mail with mautic", error);
        });
        return
      }
    },
  },

  watch: {
    tel() {
      // console.log("Tel watched")
      let newPhone = new Array();

      if (this.selectedPhoneLanguage.phone != "Other") {
        // console.log("Country code selected Active");
        newPhone = phoneVal(this.tel, this.selectedPhoneLanguage.phone, true);
        if (newPhone.length != 0) {
          this.telTemp = newPhone[0];
        } 
      } 
      else {
        newPhone = phoneVal(this.tel, "", true);
        if (newPhone.length != 0) {
          this.telTemp = newPhone[0];
        } 
      }
    },
  },

  computed: {
    color(){
      if(this.surveyData.color){
        return this.surveyData.color
      }
      else{
        return "#cccccc"
      }
    },
    valid(){
      if(this.clientInformationValid){
        return true;
      }
      else{
        return false
      }
    }
  }
};
</script>
<style>
  .survey-wrapper{
    width: 100%;
    max-width: 600px;
    margin: 20px auto;
    padding: 20px;
  }
</style>